import React from "react";
import { css } from "@emotion/core";
import { Dropdown, Field, useTheme } from "@zapier/design-system";
import {
  SupportedPaymentMethod,
  PaymentSourceType,
} from "@zapier/payment/esm/types";

type Props = {
  currentMethod: PaymentSourceType | null;
  onChange: (method: PaymentSourceType, hasSwitched: boolean) => void;
  supportedMethods: Array<SupportedPaymentMethod>;
};

const methodItems = {
  [PaymentSourceType.card]: {
    label: "Credit or debit card",
    value: PaymentSourceType.card,
  },
  [PaymentSourceType.paypal]: {
    label: "PayPal",
    value: PaymentSourceType.paypal,
  },
  [PaymentSourceType.bank]: {
    label: "Bank transfer (US only)",
    value: PaymentSourceType.bank,
  },
  [PaymentSourceType.manual]: undefined,
};

function isNotNullish<T>(value: T): value is NonNullable<T> {
  return value !== undefined && value !== null;
}

const rootCss = css`
  min-width: 180px;
`;

const PaymentMethodSelect: React.FC<Props> = ({
  currentMethod,
  onChange,
  supportedMethods = [],
}) => {
  const { isRebrand } = useTheme();
  return (
    <div css={rootCss}>
      {isRebrand ? (
        <Field
          label={`${currentMethod ? "Switch" : "Add a"} payment method`}
          renderInput={() => (
            <Dropdown
              items={supportedMethods
                .map((m: SupportedPaymentMethod) => methodItems[m.method])
                .filter(isNotNullish)
                .filter(m => m.value !== currentMethod)}
              menuAriaLabel="List of supported payment methods"
              onChange={item => onChange(item.value, false)}
              placeholder={`${
                currentMethod ? "Switch" : "Add a"
              } payment method`}
              {...(currentMethod
                ? { selectedItem: methodItems[currentMethod] }
                : {})}
            />
          )}
        />
      ) : (
        <Dropdown
          items={supportedMethods
            .map((m: SupportedPaymentMethod) => methodItems[m.method])
            .filter(isNotNullish)
            .filter(m => m.value !== currentMethod)}
          menuAriaLabel="List of supported payment methods"
          onChange={item => onChange(item.value, false)}
          placeholder={`${currentMethod ? "Switch" : "Add"} Payment Method`}
        />
      )}
    </div>
  );
};

export default PaymentMethodSelect;
